import React from 'react';

/**
 * 错误状态组件
 */
const ErrorState: React.FC<{
  handleClick?: Function,
}> = ({ handleClick }) => {
  return (
    <div className="coupon-wall-empty">
      <div className="coupon-wall-empty-text">
        暂时没有可领的红包，手动刷新试试吧~
      </div>
      <div className="coupon-wall-empty-button" onClick={() => handleClick?.()}>
        刷新
      </div>
    </div>
  );
};

export default ErrorState;

